/* eslint-disable */
// Generated by scripts/generate-dropdown-usage-registry.js.
// Do not edit manually; update component dropdown references and regenerate.

export const DROPDOWN_USAGE_REGISTRY = {
  "Activity Log Market": [
    {
      "component": "Advanced Activity Log",
      "area": "Apps / Activity Log",
      "source": "src/components/AppsPage/ActivityLog/AdvancedActivityLog.js"
    }
  ],
  "Activity Log Status": [
    {
      "component": "Advanced Activity Log",
      "area": "Apps / Activity Log",
      "source": "src/components/AppsPage/ActivityLog/AdvancedActivityLog.js"
    }
  ],
  "Additional Skid For VMS": [
    {
      "component": "Skid Construction",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/SkidConstruction.js"
    }
  ],
  "Assembler": [
    {
      "component": "Assembly Assembler Manager",
      "area": "Assembly",
      "source": "src/components/AssemblyPage/AssemblyAssemblerManager.js"
    },
    {
      "component": "Assembly Schedule",
      "area": "Assembly",
      "source": "src/components/AssemblyPage/AssemblySchedule.js"
    }
  ],
  "Assembly Assembler": [
    {
      "component": "Assembly Schedule",
      "area": "Assembly",
      "source": "src/components/AssemblyPage/AssemblySchedule.js"
    }
  ],
  "Assembly Issue Status": [
    {
      "component": "Assembly Schedule",
      "area": "Assembly",
      "source": "src/components/AssemblyPage/AssemblySchedule.js"
    }
  ],
  "Assembly Issues Comments Status": [
    {
      "component": "Assembly Schedule",
      "area": "Assembly",
      "source": "src/components/AssemblyPage/AssemblySchedule.js"
    }
  ],
  "Assembly Issues Status": [
    {
      "component": "Assembly Schedule",
      "area": "Assembly",
      "source": "src/components/AssemblyPage/AssemblySchedule.js"
    }
  ],
  "Assembly Project Status": [
    {
      "component": "Assembly Schedule",
      "area": "Assembly",
      "source": "src/components/AssemblyPage/AssemblySchedule.js"
    }
  ],
  "Assembly Type": [
    {
      "component": "Assembly Schedule",
      "area": "Assembly",
      "source": "src/components/AssemblyPage/AssemblySchedule.js"
    }
  ],
  "Backflow Preventer": [
    {
      "component": "HC Requirements",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/HCRequirements.js"
    }
  ],
  "Bill/ Credit To": [
    {
      "component": "Change Order Items",
      "area": "Job details / Change Orders",
      "source": "src/components/JobDetailPage/ChangeOrders/ChangeOrderItems.js"
    }
  ],
  "Booking Additional Sales": [
    {
      "component": "Bookings Log",
      "area": "Apps / Bookings Log",
      "source": "src/components/AppsPage/BookingsLog/BookingsLog.js"
    },
    {
      "component": "New Booking Modal",
      "area": "Apps / Bookings Log",
      "source": "src/components/AppsPage/BookingsLog/NewBookingModal.js"
    },
    {
      "component": "Sales Targets",
      "area": "Apps / Bookings Log",
      "source": "src/components/AppsPage/BookingsLog/SalesTargets.js"
    }
  ],
  "Booking Rep Type": [
    {
      "component": "Sales Targets",
      "area": "Apps / Bookings Log",
      "source": "src/components/AppsPage/BookingsLog/SalesTargets.js"
    }
  ],
  "Booking Reps": [
    {
      "component": "Bookings Log",
      "area": "Apps / Bookings Log",
      "source": "src/components/AppsPage/BookingsLog/BookingsLog.js"
    },
    {
      "component": "New Booking Modal",
      "area": "Apps / Bookings Log",
      "source": "src/components/AppsPage/BookingsLog/NewBookingModal.js"
    },
    {
      "component": "Sales Targets",
      "area": "Apps / Bookings Log",
      "source": "src/components/AppsPage/BookingsLog/SalesTargets.js"
    }
  ],
  "Carrier": [
    {
      "component": "Sold To Ship To",
      "area": "Job details / Sales",
      "source": "src/components/JobDetailPage/Sales/SoldToShipTo.js"
    }
  ],
  "Coating For Skid": [
    {
      "component": "Skid Construction",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/SkidConstruction.js"
    }
  ],
  "Color": [
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    },
    {
      "component": "Station Enclosure",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/StationEnclosure.js"
    }
  ],
  "Column Material": [
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "Container Terms": [
    {
      "component": "International Shipping",
      "area": "Job details / Sales",
      "source": "src/components/JobDetailPage/Sales/InternationalShipping.js"
    }
  ],
  "Control System": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Cooling Fans": [
    {
      "component": "Station Enclosure",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/StationEnclosure.js"
    }
  ],
  "CSO Utilization Reason": [
    {
      "component": "Assigned Engineering Jobs",
      "area": "User workspace",
      "source": "src/components/UserPage/AssignedEngineeringJobs.js"
    }
  ],
  "Customer Request Type": [
    {
      "component": "Bookings Log",
      "area": "Apps / Bookings Log",
      "source": "src/components/AppsPage/BookingsLog/BookingsLog.js"
    }
  ],
  "Discharge Filter Model": [
    {
      "component": "Discharge Filter",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Filtration/DischargeFilter.js"
    }
  ],
  "Discharge Filter Type": [
    {
      "component": "Discharge Filter",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Filtration/DischargeFilter.js"
    }
  ],
  "Discharge Head Material": [
    {
      "component": "Main Pump",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Pumps/MainPump.js"
    }
  ],
  "Disconnect Actual Size": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Disconnect Type": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Display": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Drawing Status": [
    {
      "component": "Job General Project Info RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralProjectInfoRF.js"
    }
  ],
  "Drawing Type": [
    {
      "component": "Job General Project Info RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralProjectInfoRF.js"
    }
  ],
  "Electrical Enclosure Actual Size": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Electrical Enclosure Location": [
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    }
  ],
  "Electrical Enclosure Material": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Electrical Enclosure Paint": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Enclosure Cooling": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Enclosure Type": [
    {
      "component": "Station Enclosure",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/StationEnclosure.js"
    }
  ],
  "Exterior Lighting": [
    {
      "component": "Station Enclosure",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/StationEnclosure.js"
    }
  ],
  "External Lighting": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "External Power Connection": [
    {
      "component": "Station Enclosure",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/StationEnclosure.js"
    }
  ],
  "FCC Type": [
    {
      "component": "General Electrical",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/GeneralElectrical.js"
    },
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    }
  ],
  "Filter Flush Type": [
    {
      "component": "Discharge Filter",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Filtration/DischargeFilter.js"
    }
  ],
  "Filter Manufacturer": [
    {
      "component": "Discharge Filter",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Filtration/DischargeFilter.js"
    },
    {
      "component": "Inlet Screen",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Filtration/InletScreen.js"
    }
  ],
  "Flow Meter Location": [
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    }
  ],
  "Flow Meter Type": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    },
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "Flush Valve Type": [
    {
      "component": "Discharge Filter",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Filtration/DischargeFilter.js"
    }
  ],
  "Foot Valve Required": [
    {
      "component": "HC Requirements",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/HCRequirements.js"
    }
  ],
  "Generic Yes/ No": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    },
    {
      "component": "Job General Project Info RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralProjectInfoRF.js"
    },
    {
      "component": "Fertigation",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Fertigation.js"
    },
    {
      "component": "Fill Sources",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/FillSources.js"
    },
    {
      "component": "Pump Table",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Pumps/PumpTable.js"
    },
    {
      "component": "Skid Construction",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/SkidConstruction.js"
    },
    {
      "component": "Sky Harvester",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/SkyHarvester.js"
    },
    {
      "component": "Station Enclosure",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/StationEnclosure.js"
    },
    {
      "component": "International Shipping",
      "area": "Job details / Sales",
      "source": "src/components/JobDetailPage/Sales/InternationalShipping.js"
    },
    {
      "component": "Sold To Ship To",
      "area": "Job details / Sales",
      "source": "src/components/JobDetailPage/Sales/SoldToShipTo.js"
    },
    {
      "component": "Edit Job Modal",
      "area": "Job schedule",
      "source": "src/components/JobSchedulePage/EditJobModal.js"
    }
  ],
  "HDPE Accessory for Sub Pump": [
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "Hose Type": [
    {
      "component": "Fertigation",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Fertigation.js"
    }
  ],
  "HTS Code": [
    {
      "component": "International Shipping",
      "area": "Job details / Sales",
      "source": "src/components/JobDetailPage/Sales/InternationalShipping.js"
    }
  ],
  "IncoTerms": [
    {
      "component": "International Shipping",
      "area": "Job details / Sales",
      "source": "src/components/JobDetailPage/Sales/InternationalShipping.js"
    }
  ],
  "Inlet Filter Model": [
    {
      "component": "Inlet Screen",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Filtration/InletScreen.js"
    }
  ],
  "Inlet Filter Type": [
    {
      "component": "Inlet Screen",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Filtration/InletScreen.js"
    }
  ],
  "Inlet Pressure Control": [
    {
      "component": "HC Requirements",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/HCRequirements.js"
    }
  ],
  "Installation Service Type": [
    {
      "component": "Sold To Ship To",
      "area": "Job details / Sales",
      "source": "src/components/JobDetailPage/Sales/SoldToShipTo.js"
    }
  ],
  "Interior Panel Lighting": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Iso Valve Operator": [
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "Iso Valve Size": [
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "Iso Valve Style": [
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "Issue Status": [
    {
      "component": "Assembly Schedule",
      "area": "Assembly",
      "source": "src/components/AssemblyPage/AssemblySchedule.js"
    }
  ],
  "Job Status": [
    {
      "component": "Edit Job Modal",
      "area": "Job schedule",
      "source": "src/components/JobSchedulePage/EditJobModal.js"
    },
    {
      "component": "New Job Modal",
      "area": "Job schedule",
      "source": "src/components/JobSchedulePage/NewJobModal.js"
    },
    {
      "component": "Schedule Job Modal",
      "area": "Job schedule",
      "source": "src/components/JobSchedulePage/ScheduleJobModal.js"
    }
  ],
  "Job Type": [
    {
      "component": "Edit Job Modal",
      "area": "Job schedule",
      "source": "src/components/JobSchedulePage/EditJobModal.js"
    },
    {
      "component": "New Job Modal",
      "area": "Job schedule",
      "source": "src/components/JobSchedulePage/NewJobModal.js"
    },
    {
      "component": "Schedule Job Modal",
      "area": "Job schedule",
      "source": "src/components/JobSchedulePage/ScheduleJobModal.js"
    }
  ],
  "Jockey Sequence": [
    {
      "component": "Sequence Of Operations",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/SequenceOfOperations.js"
    },
    {
      "component": "Main Pump",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Pumps/MainPump.js"
    },
    {
      "component": "Pumps",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Pumps/Pumps.js"
    }
  ],
  "Level Sensing Method": [
    {
      "component": "Level Controls",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/LevelControls.js"
    }
  ],
  "Main Check Valve Design": [
    {
      "component": "Main Pump",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Pumps/MainPump.js"
    }
  ],
  "Main Pump Seal Type": [
    {
      "component": "Main Pump",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Pumps/MainPump.js"
    }
  ],
  "Main Shaft Material": [
    {
      "component": "Main Pump",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Pumps/MainPump.js"
    }
  ],
  "Market": [
    {
      "component": "Manage Activity Log",
      "area": "Apps / Activity Log",
      "source": "src/components/AppsPage/ActivityLog/ManageActivityLog.js"
    },
    {
      "component": "Bookings Log",
      "area": "Apps / Bookings Log",
      "source": "src/components/AppsPage/BookingsLog/BookingsLog.js"
    },
    {
      "component": "New Booking Modal",
      "area": "Apps / Bookings Log",
      "source": "src/components/AppsPage/BookingsLog/NewBookingModal.js"
    },
    {
      "component": "Sales Targets",
      "area": "Apps / Bookings Log",
      "source": "src/components/AppsPage/BookingsLog/SalesTargets.js"
    },
    {
      "component": "Price Breakdown",
      "area": "Job details / Sales",
      "source": "src/components/JobDetailPage/Sales/PriceBreakdown.js"
    }
  ],
  "Notification Of Shipment": [
    {
      "component": "Sold To Ship To",
      "area": "Job details / Sales",
      "source": "src/components/JobDetailPage/Sales/SoldToShipTo.js"
    }
  ],
  "NP CSM Job Status": [
    {
      "component": "Csm Enclosure Table",
      "area": "User workspace",
      "source": "src/components/UserPage/CsmEnclosureTable.js"
    }
  ],
  "NP CSM Preflight": [
    {
      "component": "Csm Enclosure Table",
      "area": "User workspace",
      "source": "src/components/UserPage/CsmEnclosureTable.js"
    }
  ],
  "NP Delivery Status": [
    {
      "component": "Csm Enclosure Table",
      "area": "User workspace",
      "source": "src/components/UserPage/CsmEnclosureTable.js"
    }
  ],
  "NP Task Status": [
    {
      "component": "Csm Enclosure Table",
      "area": "User workspace",
      "source": "src/components/UserPage/CsmEnclosureTable.js"
    }
  ],
  "OTD Options": [
    {
      "component": "On Time Delivery",
      "area": "User workspace",
      "source": "src/components/UserPage/OnTimeDelivery.js"
    }
  ],
  "OTD Override Reason": [
    {
      "component": "On Time Delivery",
      "area": "User workspace",
      "source": "src/components/UserPage/OnTimeDelivery.js"
    }
  ],
  "Packing List Owner": [
    {
      "component": "Assembly Schedule",
      "area": "Assembly",
      "source": "src/components/AssemblyPage/AssemblySchedule.js"
    }
  ],
  "Packing List Status": [
    {
      "component": "Assembly Schedule",
      "area": "Assembly",
      "source": "src/components/AssemblyPage/AssemblySchedule.js"
    }
  ],
  "Packing List Type": [
    {
      "component": "Assembly Schedule",
      "area": "Assembly",
      "source": "src/components/AssemblyPage/AssemblySchedule.js"
    }
  ],
  "Panel Action": [
    {
      "component": "Panel Sizing WIP",
      "area": "Engineering",
      "source": "src/components/EngineeringPage/PanelSizingWIP.js"
    }
  ],
  "Panel Orientation": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Panel Review Action": [
    {
      "component": "Panel Sizing WIP",
      "area": "Engineering",
      "source": "src/components/EngineeringPage/PanelSizingWIP.js"
    }
  ],
  "Panel Review Status": [
    {
      "component": "Log",
      "area": "Engineering",
      "source": "src/components/EngineeringPage/Log.js"
    },
    {
      "component": "Panel Sizing Log",
      "area": "Engineering",
      "source": "src/components/EngineeringPage/PanelSizingLog.js"
    },
    {
      "component": "Panel Sizing WIP",
      "area": "Engineering",
      "source": "src/components/EngineeringPage/PanelSizingWIP.js"
    },
    {
      "component": "Possible Review",
      "area": "Engineering",
      "source": "src/components/EngineeringPage/PossibleReview.js"
    },
    {
      "component": "Schematics Review",
      "area": "Engineering",
      "source": "src/components/EngineeringPage/SchematicsReview.js"
    },
    {
      "component": "Upcoming Review",
      "area": "Engineering",
      "source": "src/components/EngineeringPage/UpcomingReview.js"
    }
  ],
  "Panel Sizing Action": [
    {
      "component": "Panel Sizing WIP",
      "area": "Engineering",
      "source": "src/components/EngineeringPage/PanelSizingWIP.js"
    }
  ],
  "Ph Display": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Pipe Coating": [
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "Pipe Color": [
    {
      "component": "Drop Pipe Specs",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/DropPipeSpecs.js"
    },
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "Piping Material": [
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "Pond Fill Type": [
    {
      "component": "Fill Sources",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/FillSources.js"
    }
  ],
  "Power Configuration": [
    {
      "component": "General Electrical",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/GeneralElectrical.js"
    },
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    }
  ],
  "Prime System": [
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    },
    {
      "component": "HC Requirements",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/HCRequirements.js"
    }
  ],
  "Product": [
    {
      "component": "Bookings Log",
      "area": "Apps / Bookings Log",
      "source": "src/components/AppsPage/BookingsLog/BookingsLog.js"
    }
  ],
  "Project Code": [
    {
      "component": "Advanced Activity Log",
      "area": "Apps / Activity Log",
      "source": "src/components/AppsPage/ActivityLog/AdvancedActivityLog.js"
    },
    {
      "component": "Manage Activity Log",
      "area": "Apps / Activity Log",
      "source": "src/components/AppsPage/ActivityLog/ManageActivityLog.js"
    }
  ],
  "Project Status": [
    {
      "component": "Job General Project Info RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralProjectInfoRF.js"
    }
  ],
  "PRV Size": [
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "PRV Type": [
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "Quantity 10": [
    {
      "component": "Fertigation",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Fertigation.js"
    }
  ],
  "Quantity 25": [
    {
      "component": "Fertigation",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Fertigation.js"
    }
  ],
  "Quill Type": [
    {
      "component": "Fertigation",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Fertigation.js"
    }
  ],
  "Reason For Change": [
    {
      "component": "Change Order Items",
      "area": "Job details / Change Orders",
      "source": "src/components/JobDetailPage/ChangeOrders/ChangeOrderItems.js"
    }
  ],
  "Reason Late": [
    {
      "component": "Assigned Engineering Jobs",
      "area": "User workspace",
      "source": "src/components/UserPage/AssignedEngineeringJobs.js"
    }
  ],
  "Regulatory Compliance": [
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    }
  ],
  "Remote Relay": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Request Type": [
    {
      "component": "Advanced Activity Log",
      "area": "Apps / Activity Log",
      "source": "src/components/AppsPage/ActivityLog/AdvancedActivityLog.js"
    },
    {
      "component": "Manage Activity Log",
      "area": "Apps / Activity Log",
      "source": "src/components/AppsPage/ActivityLog/ManageActivityLog.js"
    }
  ],
  "Retrofit Kit Type": [
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    }
  ],
  "RTU Accessory": [
    {
      "component": "Telemetry",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Telemetry.js"
    }
  ],
  "Salinity Display": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "SCCR Rating": [
    {
      "component": "General Electrical",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/GeneralElectrical.js"
    },
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    }
  ],
  "Select Job Site Services Included": [
    {
      "component": "Sold To Ship To",
      "area": "Job details / Sales",
      "source": "src/components/JobDetailPage/Sales/SoldToShipTo.js"
    }
  ],
  "Site Voltage": [
    {
      "component": "General Electrical",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/GeneralElectrical.js"
    },
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    }
  ],
  "Skid Color": [
    {
      "component": "Skid Construction",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/SkidConstruction.js"
    }
  ],
  "Skid Construction": [
    {
      "component": "Skid Construction",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/SkidConstruction.js"
    }
  ],
  "Special Height": [
    {
      "component": "Station Enclosure",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/StationEnclosure.js"
    }
  ],
  "Special Terms Approved By": [
    {
      "component": "Sold To Ship To",
      "area": "Job details / Sales",
      "source": "src/components/JobDetailPage/Sales/SoldToShipTo.js"
    }
  ],
  "Station Configuration": [
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    }
  ],
  "Station Drawing From": [
    {
      "component": "HC Requirements",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/HCRequirements.js"
    }
  ],
  "Station Hardware": [
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "Station Heating": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Station Location": [
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    }
  ],
  "Station To Station": [
    {
      "component": "Telemetry",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Telemetry.js"
    }
  ],
  "Station Type": [
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    }
  ],
  "Strainer Manufacturer": [
    {
      "component": "Discharge Strainer",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Filtration/DischargeStrainer.js"
    },
    {
      "component": "Inlet Strainer",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Filtration/InletStrainer.js"
    }
  ],
  "Strainer Type": [
    {
      "component": "Discharge Strainer",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Filtration/DischargeStrainer.js"
    },
    {
      "component": "Inlet Strainer",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Filtration/InletStrainer.js"
    }
  ],
  "Sub Pump Discharge Hose Type": [
    {
      "component": "Pump Manifold Piping",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/PumpManifoldPiping.js"
    }
  ],
  "Suction Line Config": [
    {
      "component": "HC Requirements",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/HCRequirements.js"
    }
  ],
  "Suction Line Material": [
    {
      "component": "HC Requirements",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/HCRequirements.js"
    }
  ],
  "Suction Lines By": [
    {
      "component": "HC Requirements",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/HCRequirements.js"
    }
  ],
  "Supply Type": [
    {
      "component": "Regulated Power",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/RegulatedPower.js"
    },
    {
      "component": "Un Regulated Power",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/UnRegulatedPower.js"
    }
  ],
  "Surge Protection": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Tank Bottom Type": [
    {
      "component": "Fertigation",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Fertigation.js"
    }
  ],
  "Telemetry Accessory Type": [
    {
      "component": "Telemetry Accessories",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/TelemetryAccessories.js"
    }
  ],
  "Telemetry Provider": [
    {
      "component": "Telemetry",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Telemetry.js"
    }
  ],
  "Telemetry Software Version": [
    {
      "component": "Telemetry",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Telemetry.js"
    }
  ],
  "Telemetry Type": [
    {
      "component": "Telemetry",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Telemetry.js"
    }
  ],
  "Test Criteria": [
    {
      "component": "Job General Project Info RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralProjectInfoRF.js"
    },
    {
      "component": "Edit Job Modal",
      "area": "Job schedule",
      "source": "src/components/JobSchedulePage/EditJobModal.js"
    }
  ],
  "textarea": [
    {
      "component": "Shipping Dashboard",
      "area": "Shipping Page",
      "source": "src/components/ShippingPage/ShippingDashboard.js"
    }
  ],
  "Tracker Type": [
    {
      "component": "Job General Specs RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralSpecsRF.js"
    }
  ],
  "VFD": [
    {
      "component": "Pump Table",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Pumps/PumpTable.js"
    }
  ],
  "Watertronics Fertigation": [
    {
      "component": "Fertigation",
      "area": "Job details / Mechanical",
      "source": "src/components/JobDetailPage/Mechanical/Fertigation.js"
    }
  ],
  "Window Kit": [
    {
      "component": "Options",
      "area": "Job details / Electrical",
      "source": "src/components/JobDetailPage/Electrical/Options.js"
    }
  ],
  "Zones": [
    {
      "component": "Job General Project Info RF",
      "area": "Job details / General",
      "source": "src/components/JobDetailPage/General/JobGeneralProjectInfoRF.js"
    }
  ]
};

const NORMALIZED_DROPDOWN_USAGE = Object.fromEntries(
  Object.entries(DROPDOWN_USAGE_REGISTRY).map(([dropdownType, usages]) => [
    dropdownType.trim().toLowerCase(),
    usages,
  ])
);

export const getDropdownUsage = (dropdownType) => (
  NORMALIZED_DROPDOWN_USAGE[String(dropdownType || '').trim().toLowerCase()] || []
);
